import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import 'whatwg-fetch';

import styles from './contact-form.scss';

import Svg from '../../common/components/Svg';

import chevronSvg from '../../common/assets/icons/chevron-right.svg';
import loadingSvg from './assets/spinner.svg';

class ContactForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      companyInput: '',
      nameInput: '',
      emailInput: '',
      phoneInput: '',
      subjectInput: props.subjectSelected,
      hostingInput: 'medium',
      messageInput: '',
      errors: {},
      formSent: false,
      formSendError: false,
      isLoading: false,
    };

    this.subjects = {
      none: 'Välj ärende',
      orderHosting: '1:st Line Support',
      orderWebsite: '2:nd Line Support',
      misc: 'Övrigt',
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.validateForm = this.validateForm.bind(this);

    this.$formContainer = null;
  }

  handleInputChange(inputName) {
    return (event) => {
      this.setState({ [inputName]: event.currentTarget.value });
    };
  }

  validateForm(formData) {
    const errors = {};
    if (formData.company.trim().length === 0) {
      errors.company = 'Du måste ange ditt företag';
    }

    if (formData.name.trim().length === 0) {
      errors.name = 'Du måste fylla i ditt namn';
    }

    if (!formData.email.trim().match(/[^@]@.+\..+/)) {
      errors.email = 'Du måste fylla i en giltig e-post';
    }

    if (formData.subject.trim() === 'none' || formData.subject.trim().length === 0) {
      errors.subject = 'Du måste välja ett ämne';
    }

    if (
      formData.subject.trim() === 'orderHosting'
      && ['xxs', 'xs', 's', 'm', 'l', 'xl', 'xxl'].indexOf(formData.hosting.trim()) < 0
    ) {
      errors.hosting = 'Du måste välja antal supportkunder';
    }

    this.setState({ errors });
    window.scrollTo(
      0,
      // Scoroll position + formContainer's offset to viewpport
      (window.scrollY + this.$formContainer.getBoundingClientRect().top)
    );

    return errors;
  }

  handleSubmit(event) {
    event.preventDefault();

    const formData = {
      company: this.state.companyInput,
      name: this.state.nameInput,
      email: this.state.emailInput,
      phone: this.state.phoneInput,
      subject: this.state.subjectInput,
      hosting: this.state.subjectInput === 'orderHosting' ? this.state.hostingInput : null,
      message: this.state.messageInput,
    };

    const validateResult = this.validateForm(formData);

    if (Object.keys(validateResult).length > 0) {
      return;
    }

    const formDataToPost = new window.FormData();

    Object.keys(formData).forEach((formDataKey) => {
      formDataToPost.append(formDataKey, formData[formDataKey]);
    });

    this.setState({ formError: false, isLoading: true });
    window.fetch('/mail.php', {
      method: 'POST',
      body: formDataToPost,
    })
    .then((response) => {
      if (response.status !== 201) {
        // eslint-disable-next-line no-console
        console.error(response);
        throw new Error(`Error from server: ${response.statusText}`);
      }

      this.setState({ formSent: true, isLoading: false });
      window.scrollTo(
        0,
        (window.scrollY - (window.innerHeight / 2)) // Center of screen
          + (this.$formContainer.getBoundingClientRect().top / 2) // + half the contact form
      );
    })
    .catch((error) => {
        // eslint-disable-next-line no-console
      console.error(error);
      this.setState({ formSent: false, formSendError: true, isLoading: false });
    }, 2000);
  }

  renderForm() {
    let extraDropdown = null;

    if (this.state.subjectInput === 'orderHosting') {
      extraDropdown = (
        <div className={styles.formControl}>
          <label htmlFor="hostingPackage">
            Välj antal supportkunder hos er som skall betjänas
            <span className={styles.required}>*</span>
          </label>
          <span className={styles.error}>{this.state.errors.hosting}</span>
          <select
            name="hostingPackage"
            id="hostingPackage"
            className={this.state.errors.hosting ? styles.inputError : null}
            required
            value={this.state.hostingInput}
            onChange={this.handleInputChange('hostingInput')}
          >
            {Object.keys(this.props.hostingPackages).map(key => (
              <option value={key} key={key}>{this.props.hostingPackages[key]}</option>
          ))}
          </select>
        </div>
      );
    }

    return (
      <form action="/mail.php" method="post" onSubmit={this.handleSubmit}>
        <h2>{this.props.headline}</h2>

        {this.props.content}

        <div className={styles.formWrapper}>
          <div className={styles.formControl}>
            <label htmlFor="company">
            Företag
            <span className={styles.required}>*</span>
            </label>
            <span className={styles.error}>{this.state.errors.company}</span>
            <input
              type="text"
              name="company"
              id="company"
              placeholder="Ert företagsnamn"
              className={this.state.errors.company ? styles.inputError : null}
              required
              value={this.state.companyInput}
              onChange={this.handleInputChange('companyInput')}
            />
          </div>

          <div className={styles.formControl}>
            <label htmlFor="name">
              Namn
              <span className={styles.required}>*</span>
            </label>
            <span className={styles.error}>{this.state.errors.name}</span>
            <input
              type="text"
              name="name"
              id="name"
              placeholder="Namn"
              className={this.state.errors.name ? styles.inputError : null}
              required
              value={this.state.nameInput}
              onChange={this.handleInputChange('nameInput')}
            />
          </div>

          <div className={styles.formControl}>
            <label htmlFor="email">
              E-post
              <span className={styles.required}>*</span>
            </label>
            <span className={styles.error}>{this.state.errors.email}</span>
            <input
              type="email"
              name="email"
              id="email"
              placeholder="namn@foretag.se"
              className={this.state.errors.email ? styles.inputError : null}
              required
              value={this.state.emailInput}
              onChange={this.handleInputChange('emailInput')}
            />
          </div>

          <div className={styles.formControl}>
            <label htmlFor="phone">
              Telefonnummer
            </label>
            <span className={styles.error}>{this.state.errors.phone}</span>
            <input
              type="phone"
              name="phone"
              id="phone"
              placeholder="070 123 45 67"
              value={this.state.phoneInput}
              onChange={this.handleInputChange('phoneInput')}
            />
          </div>

          <div className={styles.formControl}>
            <label htmlFor="subject">
              Ärende
              <span className={styles.required}>*</span>
            </label>
            <span className={styles.error}>{this.state.errors.subject}</span>

            <select
              name="subject"
              id="subject"
              className={this.state.errors.subject ? styles.inputError : null}
              required
              value={this.state.subjectInput}
              onChange={this.handleInputChange('subjectInput')}
            >
              {Object.keys(this.subjects).map(subjectKey => (
                <option
                  key={subjectKey}
                  value={subjectKey}
                  disabled={subjectKey === 'none'}
                >{this.subjects[subjectKey]}</option>
              ))}
            </select>
          </div>

          {extraDropdown}

          <div className={styles.formControlWide}>
            <label htmlFor="message">
              Meddelande
            </label>

            <textarea
              name="message"
              id="message"
              value={this.state.messageInput}
              onChange={this.handleInputChange('messageInput')}
            />
          </div>

        </div>

        {this.state.formSendError ? (
          <div className={styles.submitError}>
          Åh nej! Något gick visst väldigt fel! <strong>Ditt meddelande har
          inte skickats.</strong> Försök gärna igen, eller använd våra
          <Link to="/kontakta-oss/"> kontaktuppgifter</Link>
          </div>
        ) : null}

        <div className={styles.submitContainer}>
          {this.state.isLoading ? (
            <Svg src={loadingSvg} className={styles.loading} />
            ) : (
              <button type="submit" className={styles.submit}>
                {this.props.ctaText}
                <Svg src={chevronSvg} className={styles.submitChevron} />
              </button>
            )}
        </div>
      </form>
    );
  }

  render() {
    return (
      <div
        className={this.props.darker ? styles.contactFormDark : styles.contactForm}
        ref={(c) => { this.$formContainer = c; }}
      >
        <div className={styles.contactFormInner}>
          {this.state.formSent
            ? (
              <div className={styles.thanks}>
                Tack för din förfrågan! Vi återkommer så snart vi kan.
              </div>
            )
            : this.renderForm()}
        </div>
      </div>
    );
  }
}

ContactForm.propTypes = {
  headline: PropTypes.string.isRequired,
  content: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
  ]),
  ctaText: PropTypes.string.isRequired,
  darker: PropTypes.bool,
  subjectSelected: PropTypes.string,
  hostingPackages: PropTypes.objectOf(PropTypes.string).isRequired,
};

ContactForm.defaultProps = {
  content: null,
  darker: false,
  subjectSelected: 'none',
};

export default ContactForm;



// WEBPACK FOOTER //
// ./blocks/ContactForm/index.js